// Shared frame interval for render throttling and animations (~60fps)
export const FRAME_INTERVAL_MS = 16
